import { jsxs, jsx } from "react/jsx-runtime";
import { ResponsiveContainer } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/component/ResponsiveContainer.js";
import { BarChart } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/chart/BarChart.js";
import { CartesianGrid } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/cartesian/CartesianGrid.js";
import { XAxis } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/cartesian/XAxis.js";
import { YAxis } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/cartesian/YAxis.js";
import { Tooltip } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/component/Tooltip.js";
import { Legend } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/component/Legend.js";
import { Bar } from "../../node_modules/.pnpm/recharts@3.8.0_@types_react@18.3.27_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1_redux@5.0.1/node_modules/recharts/es6/cartesian/Bar.js";
const DOMAIN_LABELS = {
  abstraction: "무시",
  change: "변화",
  relation: "관계"
};
function TimeAnalysisChart({ timeAnalysis, domainData }) {
  const chartData = [
    {
      name: "전체 평균",
      "Pre-AIQ": Math.round(timeAnalysis.preAvgTimeSec),
      "Post-AIQ": Math.round(timeAnalysis.postAvgTimeSec)
    },
    ...domainData.map((d) => ({
      name: DOMAIN_LABELS[d.domain] || d.domain,
      "Pre-AIQ": Math.round(d.preAvgTimeSec),
      "Post-AIQ": Math.round(d.postAvgTimeSec)
    }))
  ];
  const formatTime = (seconds) => {
    if (seconds < 60) return `${seconds}초`;
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return sec > 0 ? `${min}분 ${sec}초` : `${min}분`;
  };
  return /* @__PURE__ */ jsxs("div", { className: "p-6 bg-white rounded-xl shadow-2xs border border-gray-100", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between mb-4", children: [
      /* @__PURE__ */ jsx("h3", { className: "text-lg font-semibold text-gray-900", children: "소요 시간 분석" }),
      timeAnalysis.timeImprovedPercent > 0 && /* @__PURE__ */ jsxs("span", { className: "px-2 py-1 text-xs font-medium text-green-700 bg-green-100 rounded-full", children: [
        timeAnalysis.timeImprovedPercent.toFixed(1),
        "% 단축"
      ] })
    ] }),
    /* @__PURE__ */ jsx(ResponsiveContainer, { width: "100%", height: 280, children: /* @__PURE__ */ jsxs(BarChart, { data: chartData, barGap: 4, children: [
      /* @__PURE__ */ jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }),
      /* @__PURE__ */ jsx(XAxis, { dataKey: "name", tick: { fontSize: 13 } }),
      /* @__PURE__ */ jsx(YAxis, { tick: { fontSize: 12 }, tickFormatter: (v) => `${v}초` }),
      /* @__PURE__ */ jsx(
        Tooltip,
        {
          formatter: (value, name) => [formatTime(value), name]
        }
      ),
      /* @__PURE__ */ jsx(Legend, { wrapperStyle: { fontSize: 13 } }),
      /* @__PURE__ */ jsx(Bar, { dataKey: "Pre-AIQ", fill: "#93c5fd", radius: [4, 4, 0, 0] }),
      /* @__PURE__ */ jsx(Bar, { dataKey: "Post-AIQ", fill: "#c4b5fd", radius: [4, 4, 0, 0] })
    ] }) })
  ] });
}
export {
  TimeAnalysisChart
};
//# sourceMappingURL=TimeAnalysisChart.js.map
